export interface IUserRecordOption {
  value: string;
  label: string;
}

export interface IUserRecordOptionDto {
  Value: string;
  Label: string;
}

export interface IUserRecordOptionsDto {
  Components?: IUserRecordOptionDto[];
  ExclusionReasons?: IUserRecordOptionDto[];
}

export interface IUserRecordOptions {
  components: IUserRecordOption[];
  exclusionReasons: IUserRecordOption[];
}

export enum ComponentEnum {
  Tracker = "Tracker",
  Inverter = "Inverter",
  System = "System",
  PowerMeter = "PowerMeter",
  SiteControl = "Site Control",
  PC = "PC",
  Network = "Network",
  AP = "AP",
  Other = "Other",
}

export const USER_RECORD_OTHER_EXCLUSION_REASON = "Other";

export interface IUserRecord {
  isExclusion: boolean;
  event: string;
  recordMetadata: string | null;
  reportingSystem: string | null;
  startDate: number;
  endDate: number | null;
  reporter: string;
  componentType: string;
  componentName: string;
  description: string;
  exclusionReason: string;
  otherReasonDescription: string;
  id?: number;
  isEngineerOnly: boolean;
}

export type IUserRecordSubmission = Omit<IUserRecord, "event">;

export interface IUserRecordDto {
  EventDate?: number;
  EndDate?: number | null;
  Title?: string;
  Reporter?: string;
  ComponentType?: string;
  ComponentName?: string;
  Description?: string;
  IsExclusion?: boolean;
  ExclusionReason?: string | null;
  ExclusionManualReason?: string | null;
  Id?: number;
  RecordMetadata?: string;
  ReportingSystem?: string;
  IsEngineerOnly?: boolean;
  DeleteTimeUtc?: number | null;
}

export const ReportingSystemSomaWeb = "Soma web";

export enum RecordMetadataEnum {
  UserInput = "UserInput",
  SystemSafetyEnabled = "SystemSafetyEnabled",
  SystemSafetyDisabled = "SystemSafetyDisabled",
}

export function getUserRecordComponentOptions(): IUserRecordOption[] {
  return [ComponentEnum.Tracker, ComponentEnum.Inverter, ComponentEnum.System].map((value) => ({
    value,
    label: value,
  }));
}

export function splitUserRecordListValue(value?: string | null): string[] {
  if (!value) {
    return [];
  }

  const trimmedValue = value.trim();
  const normalizedValue =
    trimmedValue.startsWith("[") && trimmedValue.endsWith("]")
      ? trimmedValue.slice(1, -1)
      : trimmedValue;

  return normalizedValue
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

export function getComponentLabel(componentType?: string | null) {
  const values = splitUserRecordListValue(componentType);

  if (values.length === 0) {
    return componentType?.trim() || "-";
  }

  return values.join(", ");
}

function humanizeOptionValue(value: string) {
  return value.replace(/([a-z])([A-Z])/g, "$1 $2").trim();
}

export function getExclusionReasonLabel(reason?: string | null) {
  if (!reason) {
    return "";
  }

  return humanizeOptionValue(reason);
}
